import React,{ useContext } from 'react';
import styled,{css} from 'styled-components';
import { fontQuicksand } from '../../common/mixins/mixin';
import { breakpoints, device } from '../../../../app/js/utils/responsive_utilities';
import { SemContext } from '../../context/SemContext';

const InfoBadge = ({
  showSaving,
  showSubjectNameOnSelectedTile,
  subject,
  percentOff,
  savePercentage,
  oneTimeDiscount,
  planDuration
}) => {
  const { state } = useContext(SemContext)
  const { showMorePlans = false } = state;
  const discountText = oneTimeDiscount ? `${percentOff}% off for 1st ${planDuration}` : `Extra ${percentOff}% off`;
  return (
    <>
      { (!!percentOff) ? <Span showSaving={true}>{discountText}</Span> :
        (showSaving && !percentOff && savePercentage) ? <Span showSaving={false}>Save {savePercentage}%</Span> : null}
      {showSubjectNameOnSelectedTile && <Span showTitle={true} showSaving={true}>{subject.title}</Span>}
    </>
  )
}

export default InfoBadge;

const Span = styled.span`
  position: absolute;
  padding: 0 1rem 0.3rem;
  background-color: #42D3B8;
  color: #141953;
  top: ${props => props.showImage ? "-0.5rem" : "-0.1rem"};
  right: 4rem;
  border-radius: 0 0 0.8rem 0.8rem;
  ${fontQuicksand(1.2, 1.6, 7)}
  img{
    width: 5.1rem;
    height: 4.22rem;
  }
  @media ${device.Phone}{
    img{
      width: 3.52rem;
      height: 3.33rem;
    }
    ${props=> props.showImage ? css`
        right: 2.5rem;
    ` : ""}
  }

  @media (min-width: ${breakpoints.lg}px) {
    top: -0.1rem;
  }
`;
